import {
    Directive,
    ElementRef,
    HostBinding,
    inject,
    Input,
    OnChanges,
    OnInit,
    SecurityContext,
    SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppHelper } from '@app/core/app.helper';

/** Директива для подсвечивания теста (для поиска) */
@Directive({
    selector: '[highlight]',
})
export class HighlightDirective implements OnChanges, OnInit {
    private el = inject(ElementRef);
    private sanitizer = inject(DomSanitizer);

    /** Строка поиска */
    @Input('highlight') public searchTerm: string;

    @Input() public idElem: string = '';

    /** Пользовательский класс */
    @Input() customClass: string = '';

    /** Строка в которой будем искать */
    @Input() text: string;

    /** Контент элемента */
    @HostBinding('innerHtml') public content: string;

    public ngOnChanges(changes: SimpleChanges): void {
        if (!this.el.hasOwnProperty('nativeElement') || !('searchTerm' in changes)) {
            return;
        }
        this._highlightText();
    }

    /** Поиск и выделение искомого набора символов */
    private _highlightText(): void {
        const text = (this.el.nativeElement as HTMLElement).textContent;

        const searchTerm = AppHelper.escapingStringForSearch(this.searchTerm);

        if (searchTerm === '') {
            this.setContent(this.text);
        } else {
            const regex = new RegExp(searchTerm, 'gi');

            const newText = text.replace(regex, (match: string) => {
                return `<mark class="highlight ${this.customClass}">${match}</mark>`;
            });

            this.setContent(this.sanitizer.sanitize(SecurityContext.HTML, newText.length ? newText : this.text));
        }
    }

    /** Установка контента */
    private setContent(str: string): void {
        this.content = str;
    }

    public ngOnInit(): void {
        setTimeout(() => {
            this._highlightText();
        });
    }
}
